import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router";
import moment from "moment";
import {
  fetchDebts,
  fetchInvoices,
  payNow,
  fetchPDFFile
} from "../../actions/index";
import { FormattedMessage } from "react-intl";

import DashCard from "../../components/DashCard";
import Badge from "../../components/Badge";

import "../../static/style/dashboard.css";
import { setUser } from "../../actions";

class Dashboard extends Component {
  constructor(props, context) {
    super(props, context);

    this.renderCards = this.renderCards.bind(this);
    this.getStatusString = this.getStatusString.bind(this);
    this.combineInvoices = this.combineInvoices.bind(this);
    this.sortBy = this.sortBy.bind(this);
  }

  componentDidMount() {
    const token = sessionStorage.getItem("accessToken");
    if (token) {
      this.props.fetchDebts();
      this.props.fetchInvoices();
    } else {
      //console.log("no token - no login");
    }
  }

  combineInvoices(debts, invoices) {
    const combined = [];

    for (const inv in invoices) {
      if (invoices[inv].erapaiva === null) {
        invoices[inv].erapaiva = invoices[inv].seuraavapaiva;
      }
      if (invoices[inv].tila === "L" || invoices[inv].tila === "A") {
        combined.push(invoices[inv]);
      }
    }
    for (const deb in debts) {
      if (debts[deb].erapaiva === null) {
        debts[deb].erapaiva = debts[deb].seuraavapaiva;
      }
      if (
        debts[deb].tila === "VP" ||
        debts[deb].tila === "OP" ||
        debts[deb].tila === "UO"
      ) {
        combined.push(debts[deb]);
      }
    }
    this.sortBy(combined, { prop: "erapaiva" });
    return combined;
  }

  sortBy = (function() {
    var toString = Object.prototype.toString,
      // default parser function
      parse = function(x) {
        return x;
      },
      // gets the item to be sorted
      getItem = function(x) {
        var isObject = x != null && typeof x === "object";
        var isProp = isObject && this.prop in x;
        return this.parser(isProp ? x[this.prop] : x);
      };

    /**
     * Sorts an array of elements.
     *
     * @param {Array} array: the collection to sort
     * @param {Object} cfg: the configuration options
     * @property {String}   cfg.prop: property name (if it is an Array of objects)
     * @property {Boolean}  cfg.desc: determines whether the sort is descending
     * @property {Function} cfg.parser: function to parse the items to expected type
     * @return {Array}
     */
    return function sortby(array, cfg) {
      if (!(array instanceof Array && array.length)) return [];
      if (toString.call(cfg) !== "[object Object]") cfg = {};
      if (typeof cfg.parser !== "function") cfg.parser = parse;
      cfg.desc = !!cfg.desc ? -1 : 1;
      return array.sort(function(a, b) {
        a = getItem.call(cfg, a);
        b = getItem.call(cfg, b);
        return cfg.desc * (a < b ? -1 : +(a > b));
      });
    };
  })();

  getStatusString(status) {
    /** LASKUT
     *  "L", "Lähettämättä"
     "A", "Avoinna"
     "M", "Maksettu"
     "P", "Perinnässä"
     "R", "Keskeytetty"
     "X", "Peruttu"
     "K", "Kuittauksessa" (Tätä tilaa ei pitäisi henkilöasiakkaalla tulla
     vastaan)
     "Y", "Myyty"

     PERINTÄ
     "VP": Vapaaehtoinenperintä
     "OP": Oikeudellinenperintä
     "UO": Ulosottoperintä
     "LO": Loppuun peritty
     "MY": Myyty
     "XX": Lopetettu
     "PE": Peruttu
     Aktiivisia tiloja ovat VP, OP ja UO.
     */

    switch (status) {
      case "L":
        return (
          <FormattedMessage
            id="app.statuses.not_sent"
            defaultMessage="Lähettämättä"
          />
        );
      case "A":
        return (
          <FormattedMessage id="app.statuses.open" defaultMessage="Avoinna" />
        );
      case "M":
        return (
          <FormattedMessage id="app.statuses.paid" defaultMessage="Maksettu" />
        );
      case "LO":
        return (
          <FormattedMessage id="app.statuses.paid" defaultMessage="Maksettu" />
        );
      case "P":
        return (
          <FormattedMessage
            id="app.statuses.in_collection"
            defaultMessage="Perinnässä"
          />
        );
      case "R":
        return (
          <FormattedMessage
            id="app.statuses.halted"
            defaultMessage="Keskeytetty"
          />
        );
      case "X":
        return (
          <FormattedMessage
            id="app.statuses.cancelled"
            defaultMessage="Peruttu"
          />
        );
      case "K":
        return (
          <FormattedMessage
            id="app.statuses.acknowledgement"
            defaultMessage="Kuittauksessa"
          />
        );
      case "Y":
        return (
          <FormattedMessage id="app.statuses.sold" defaultMessage="Myyty" />
        );
      case "VP":
        return (
          <FormattedMessage
            id="app.statuses.in_collection"
            defaultMessage="Perinnässä"
          />
        );
      default:
        return (
          <FormattedMessage
            id="app.statuses.unknown"
            defaultMessage="Ei tiedossa"
          />
        );
    }
  }

  renderCards(assData) {
    let type = "debt";
    if (assData.laskupaiva) {
      type = "invoice";
    }

    let assNro = "-";

    if (assData.tila === "M" || assData.tila === "LO" || assData.tila === "X") {
      return null;
    }

    // Buttons for Dashboard component
    const btns = [];

    const btnSe = {
      btnText: (
        <FormattedMessage
          id="button.lbl.move_date"
          defaultMessage="SIIRRÄ ERÄPÄIVÄÄ"
        />
      ),
      btnStyle: "primary-dark",
      btnPath: `/move-due-date/${assData.id}`,
      btnKey: `btnSe-${assData.id}`
    };
    const btnMo = {
      btnText: (
        <FormattedMessage
          id="button.lbl.agreement"
          defaultMessage="MAKSA OSISSA"
        />
      ),
      btnStyle: "primary-dark",
      btnPath: `/plan/${assData.id}`,
      btnKey: `btnMo-${assData.id}`
    };
    const btnSt = {
      btnText: (
        <FormattedMessage
          id="button.lbl.agreement_info"
          defaultMessage="SOPIMUKSEN TIEDOT"
        />
      ),
      btnStyle: "primary-dark",
      btnPath: `/plan-info/${assData.id}`,
      btnKey: `btnSt-${assData.id}`
    };

    // Status & labels for Cards
    let color = "green";
    let tila = (
      <FormattedMessage id="app.dashcard.status_ok" defaultMessage="Avoinna" />
    );
    let name = "";
    let open = "";
    let duedate = "";
    let lblSum = (
      <FormattedMessage id="app.dashcard.sum" defaultMessage="Avoin summa" />
    );
    let parts = "";
    let badge = "";
    let bills = [];

    // Check if assignment has sent bills
    if (assData.kirje_set && assData.kirje_set.length > 0) {
      for (const index in assData.kirje_set) {
        if (assData.kirje_set[index].tiedostolinkki !== null) {
          bills.push(assData.kirje_set[index]);
        }
      }
      if (bills.length === 0) {
        bills = null;
      }
    } else {
      bills = null;
    }

    const due = moment(assData.erapaiva, "YYYY-MM-DD").set({hour: 23, minute: 59, second: 59});
    const now = moment();

    let payBtn = assData.vaihe && assData.vaihe.esta_maksu ? null : (
      <FormattedMessage id="button.lbl.pay" defaultMessage="MAKSA HETI" />
    );
    tila = this.getStatusString(assData.tila);

    if (
      typeof assData.maksusopimus === "undefined" ||
      assData.maksusopimus === null
    ) {
      if (assData.nro) {
        assNro = assData.nro;
      } else {
        assNro = assData.id;
      }

      const partial_payment_ok = type === "debt" && assData.salli_maksusopimus;

      if (due > now) {
        color = "green";

        if (partial_payment_ok) {
          btns.push(btnMo);
        }
        if (type === "invoice" && assData.alk_erapaiva === assData.erapaiva && assData.paamies.esta_erapaivan_siirto_as_online === false) {
          btns.push(btnSe);
        }
      }

      if (due < now) {
        color = "orange";
        badge = (
          <Badge
            badgeColor={"badge-danger"}
            text={
              <FormattedMessage
                id="app.dashcard.status_late"
                defaultMessage="MYÖHÄSSÄ"
              />
            }
          />
        );
      }

      name = assData.paamies.nimi;
      open = assData.avoinna;
      duedate = due.format("D.M.YYYY"); // assData.erapaiva

      if (
        assData.tila === "P" ||
        assData.tila === "VP" ||
        assData.tila === "OP"
      ) {
        color = "red";
        open = assData.avoinna_nyk;
      }
    } else {
      let current = null;
      let round = 1;
      assNro = assData.id;

      for (const part of assData.maksusopimus.maksusopimusera_erittely) {
        if (part.maksupaiva == null) {
          current = part;
          break;
        }
        round++;
      }
      if (current) {
        const due = moment(current.erapaiva, "YYYY-MM-DD").set({hour: 23, minute: 59, second: 59});
        // const close = moment(current.erapaiva, "YYYY-MM-DD").subtract(3, "d");

        if (due > now) {
          color = "green";
          tila = (
            <FormattedMessage
              id="app.dashcard.status_part"
              defaultMessage="Maksusopimus voimassa"
            />
          );
        }
        // TODO Check what is the state of 'osamaksu' when it's no valid anymore due to not paying the payments
        if (due < now) {
          color = "orange";
          tila = (
            <FormattedMessage
              id="app.dashcard.status_part"
              defaultMessage="Maksusopimus voimassa"
            />
          );
          badge = (
            <Badge
              badgeColor={"badge-danger"}
              text={
                <FormattedMessage
                  id="app.dashcard.status_late"
                  defaultMessage="MYÖHÄSSÄ"
                />
              }
            />
          );
        }

        name = assData.paamies.nimi;
        open = current.summa;
        duedate = due.format("D.M.YYYY"); // current.erapaiva

        // const round = assData.maksusopimus.maksusopimusera_set.findIndex(found => found.id === assData.maksusopimus.nykyinenera.id) + 1

        lblSum = (
          <FormattedMessage
            id="app.dashcard.installment_no"
            defaultMessage="Erä"
          />
        );
        parts = `${round}/${
          assData.maksusopimus.maksusopimusera_erittely.length
        }`;
      }

      btns.push(btnSt);
      // btns.push(btnMe);

      if (assData.vaihe && assData.vaihe.esta_eramaksu) {
        payBtn = null;
      } else {
        payBtn = (
          <FormattedMessage id="button.lbl.pay_part" defaultMessage="MAKSA ERÄ"/>
        );
      }
    }

    if (assNro === "-") {
      assData = assData.viite;
    }

    return (
      <DashCard
        key={assData.id}
        id={assData.id}
        type={type}
        nro={assNro}
        name={name}
        open={open}
        due={duedate}
        status={tila}
        badge={badge}
        lblSum={lblSum}
        parts={parts}
        border={color}
        buttons={btns}
        paymentForm={assData.paymentform}
        payBtn={payBtn}
        bills={bills}
        fetchPDF={this.props.fetchPDFFile}
      />
    );
  }

  render() {
    if (this.props.error) {
      if (this.props.error === 500) {
        return <Redirect to={"/500"} />;
      } else {
        return <Redirect to={"/404"} />;
      }
    }

    if (!this.props.debts || !this.props.invoices) {
      return (
        <div className="row">
          <div className="col-sm-12">
            <h1 className="header1">
              <FormattedMessage id="app.loading" defaultMessage="Ladataan..." />
            </h1>
          </div>
        </div>
      );
    }

    if (this.props.debts || this.props.invoices) {
      let combined = false;
      combined = this.combineInvoices(this.props.debts, this.props.invoices);

      let ass = true;
      let ins = true;
      let nothing = false;

      if (combined.length === 0) {
        ass = false;
      }
      if (this.props.installments.length === 0) {
        ins = false;
      }

      if (ass === false && ins === false) {
        nothing = true;
      }

      return (
        <div className="row">
          <div className="col-sm-12">
            {ins ? (
              <div>
                <h1 className="header1">
                  <FormattedMessage
                    id="app.dashboard.agreements"
                    defaultMessage="Voimassa olevat maksusopimukset"
                  />
                </h1>
                <ul className="list-unstyled">
                  {this.props.installments
                    ? this.props.installments.map(this.renderCards)
                    : null}
                </ul>
              </div>
            ) : null}
            {ass ? (
              <div>
                <h1 className="header1">
                  <FormattedMessage
                    id="app.dashboard.open"
                    defaultMessage="Avoimet asiat"
                  />
                </h1>
                <ul className="list-unstyled">
                  {combined ? combined.map(this.renderCards) : null}
                </ul>
              </div>
            ) : null}

            {nothing ? (
              <div>
                <h1>
                  <FormattedMessage
                    id="app.dashboard.open"
                    defaultMessage="Avoimet asiat"
                  />
                </h1>
                <p>
                  <FormattedMessage
                    id="app.dashboard.no"
                    defaultMessage="Ei avoimia maksuja"
                  />
                </p>
              </div>
            ) : null}
          </div>
        </div>
      );
    }
  }
}
const mapStateToProps = function(store) {
  return {
    debts: store.debts.debts,
    installments: store.debts.installments,
    invoices: store.invoices.invoices,
    token: store.login.token,
    error: store.error.error,
    debtor: store.debts.debtor,
    payer: store.invoices.payer,
    user: store.user
  };
};

const mapDispatchToProps = dispatch => ({
  fetchDebts: pin => dispatch(fetchDebts(pin)),
  fetchInvoices: pin => dispatch(fetchInvoices(pin)),
  payNow: id => dispatch(payNow(id)),
  fetchPDFFile: path => dispatch(fetchPDFFile(path)),
  setUser: user => dispatch(setUser(user))
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Dashboard.js